/**
 * Theme component overrides
 *
 * Each component has its own override file that defines:
 * - defaultProps for setting component defaults
 * - styleOverrides.root for universal styles applied to all instances
 * - styleOverrides.{slotName} for variant-specific styles (e.g., contained, outlined, text)
 * - variants array for conditional styles based on prop combinations
 *
 * This approach uses MUI's theming system to enforce consistent styling
 * without requiring wrapper components.
 */

import type { Components, Theme } from '@mui/material/styles'

import { MuiAlertOverride } from './MuiAlert.override'
import { MuiAvatarOverride } from './MuiAvatar.override'
import { MuiButtonOverride } from './MuiButton.override'
import { MuiChipOverride } from './MuiChip.override'
import {
  MuiDialogActionsOverride,
  MuiDialogContentOverride,
  MuiDialogOverride,
  MuiDialogTitleOverride,
} from './MuiDialog.override'
import { MuiDividerOverride } from './MuiDivider.override'
import { MuiMenuOverride } from './MuiMenu.override'
import { MuiMenuItemOverride } from './MuiMenuItem.override'
import { MuiOutlinedInputOverride } from './MuiOutlinedInput.override'
import { MuiPaperOverride } from './MuiPaper.override'
import { MuiSelectOverride } from './MuiSelect.override'
import { MuiSwitchOverride } from './MuiSwitch.override'
import { MuiTextFieldOverride } from './MuiTextField.override'
import {
  MuiToggleButtonGroupOverride,
  MuiToggleButtonOverride,
} from './MuiToggleButton.override'

export const componentOverrides: Components<Theme> = {
  MuiAlert: MuiAlertOverride,
  MuiAvatar: MuiAvatarOverride,
  MuiButton: MuiButtonOverride,
  MuiChip: MuiChipOverride,
  MuiDialog: MuiDialogOverride,
  MuiDialogActions: MuiDialogActionsOverride,
  MuiDialogContent: MuiDialogContentOverride,
  MuiDialogTitle: MuiDialogTitleOverride,
  MuiDivider: MuiDividerOverride,
  MuiMenu: MuiMenuOverride,
  MuiMenuItem: MuiMenuItemOverride,
  MuiOutlinedInput: MuiOutlinedInputOverride,
  MuiPaper: MuiPaperOverride,
  MuiSelect: MuiSelectOverride,
  MuiSwitch: MuiSwitchOverride,
  MuiTextField: MuiTextFieldOverride,
  MuiToggleButton: MuiToggleButtonOverride,
  MuiToggleButtonGroup: MuiToggleButtonGroupOverride,
}
